import type { MemberRole } from "@nabble/sdk";
import { Badge } from "@nabble/ui";
import { ADMIN_ROLE_ID } from "../model/organizationRoles";

/** The roles a person holds in one organization, as chips; Administrator stands out. */
export function RoleChips({ roles }: { roles: MemberRole[] }): React.JSX.Element {
  return (
    <span style={{ display: "inline-flex", flexWrap: "wrap", gap: "var(--space-1)" }}>
      {roles.map((role) => (
        <Badge key={role.id} label={role.name} tone={role.id === ADMIN_ROLE_ID ? "info" : "neutral"} dot={false} />
      ))}
    </span>
  );
}
